//
// class for MeasureWeight data type
//
// @extends [DataFormatterType]
//
import { DataFormatterOptions } from '../DataFormatterType';

import { DataFormatNumber } from './DataFormatNumber';

/**
 * Data formatter for MeasureWeight type.
 * @ignore
 */
export class DataFormatMeasureWeight extends DataFormatNumber
{
    getName() : string
    {
        return "MeasureWeight";
    }

    /* MeasurePhysical is stored internally as inches */
    getUnitText(options ?: DataFormatterOptions) : string
    {
        return "lbs";
    }

    /**
     * format data as a number.
     * Options can have format='<numeral js template>'
     *
     * @param data
     * @param options
     * @param refObj
     */
    format(data: any, options?: any, refObj?: any): string
    {
        let result = super.format(data, options, refObj);
        return result;
    }
}

export default DataFormatMeasureWeight;
